import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";
const SOCKETS_API_BASE = `${API_BASE}/api/v1/sockets`;

export const fetchOperatorSockets = async () => {
    const response = await apiFetch(`${SOCKETS_API_BASE}/operator`);
    if (!response.ok) {
        throw new Error("Не вдалося завантажити розетки");
    }
    return await response.json();
};

export const updateSocketItem = async (id, data) => {
    const response = await apiFetch(`${SOCKETS_API_BASE}/operator/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.detail || "Помилка оновлення розетки");
    }
    return await response.json();
};
